// Set the $ variable for WP
var $ = jQuery;
// console.log('Console is Logging');

// Start AaltoMation
 $(window).scroll(function(){
	 inViewport();
 });

 $(window).resize(function(){
	 inViewport();
 });

 var h = window.innerHeight;

 function inViewport(){
	 

	 $('.aaltomation').each(function(){
		var divPos = $(this).offset().top,
 		topOfWindow = $(window).scrollTop();
		if( divPos < topOfWindow+h-100 ){
			var animationClass = $(this).data('animation-in')
			$(this).removeClass('aaltomation');
			$(this).addClass('animate__animated');
			$(this).addClass(animationClass);
		}

		if( divPos < 100 ){
			console.log('gone');
		}
	 });
 }

// console.log('Aaltomation Has Loaded');
// End AaltoMation

$('iframe').on('load', function() {
	Foundation.reInit('equalizer');
});


// Show the header on scroll
var prev = 0;
var $window = $(window);
var nav = $('.scrollhide-nav');

$window.on('scroll', function(){
  var scrollTop = $window.scrollTop();
  nav.toggleClass('hidden', scrollTop > prev);
  prev = scrollTop;
});

// var lastScrollTop; // This Varibale will store the top position

// var navbar = document.getElementById('scrollhide-nav'); // Get The NavBar

// window.addEventListener('scroll', function() {
//   //on every scroll this funtion will be called

//   var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   //This line will get the location on scroll

//   console.log(window.pageYOffset);
//   if (scrollTop > lastScrollTop) { //if it will be greater than the previous
//     if (!navbar.classList.contains("hidden")) {
//       navbar.classList.add("hidden");
//     }
//     //set the value to the negetive of height of navbar 
//   } else {
//     if (navbar.classList.contains("hidden")) {
//       navbar.classList.remove("hidden");
//     }
//   }

//   lastScrollTop = scrollTop; //New Position Stored
// });


// Hambugers
// https://jonsuh.com/hamburgers/
var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

var hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
  forEach(hamburgers, function(hamburger) {
    hamburger.addEventListener("click", function() {
      this.classList.toggle("is-active");
      $('.fullscreen-nav').fadeToggle();
    }, false);
  });
}

// Chris' Overlapt
// https://codepen.io/chrisladams/pen/wvmowNz
class Overlapt {
  constructor(el) {
    this.el = el
    this.update()
    window.addEventListener('resize', () => { this.update() })
    document.querySelector('img').addEventListener('load', () => { this.update() })
  }

  update () {
    if (!this.el) { return }
    var section = this.el.dataset.overlapClosest ?
      this.el.closest(this.el.dataset.overlapClosest) : this.el.parentNode
    var neighbor = section.nextElementSibling
    var amount = this.el.dataset.overlap ? this.el.dataset.overlap : '50'

    if (this.el.dataset.overlapBreakpoints) {
      try {
        var breakpoints = {}
        this.el.dataset.overlapBreakpoints
          .split(';')
          .forEach(function(values) {
            var tmp = values.split(':')
            breakpoints[tmp[0]] = tmp[1]
          })
        
        Object.keys(breakpoints)
          .reverse()
          .forEach(function(bp) {
            if (window.innerWidth < parseInt(bp)) {
              amount = breakpoints[bp]
            }
          })
      } catch (e) {
        console.error(e)
      }
    }

    var percentage = !amount.includes('px')
    var extraOffset = parseInt(window.getComputedStyle(section).paddingBottom)
    amount = parseInt(amount)
    if (percentage) {
      amount = this.el.clientHeight * (amount / 100)
    }

    // Set neighbor CSS spacing
    neighbor.style.paddingTop = ''
    this.el.style.marginBottom = ''
    var neighborTopPadding = parseInt(window.getComputedStyle(neighbor).paddingBottom)
    if (amount > 0) {
      neighbor.style.paddingTop = (neighborTopPadding + amount) + 'px'
      this.el.style.marginBottom = (-1 * (amount + extraOffset)) + 'px'
    }
  }
}





$( document ).ready(function() {
  Foundation.reInit('equalizer');
  
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });
});

// SCROLLY TELLING!!
gsap.registerPlugin(ScrollTrigger)

// Highlight Text on Scroll
gsap.utils.toArray(".highlighted").forEach((span) => {
  ScrollTrigger.create({
    trigger: span,
    start: "top center",
    onEnter: () => span.classList.add("highlighted-active"),
  });
});


document.addEventListener('DOMContentLoaded', function() {
    const accordionBodies = document.querySelectorAll('.tbl-accordion-body');
    const toggleLinks = document.querySelectorAll('.toggle-link');

    // Hide all accordion rows on page load
    accordionBodies.forEach(row => {
        row.style.display = 'none';
    });

    toggleLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default link behavior

            const accordionBody = this.closest('tr').nextElementSibling;
            if (accordionBody && accordionBody.classList.contains('tbl-accordion-body')) {
                accordionBody.style.display = 
                    (accordionBody.style.display === 'none' || accordionBody.style.display === '') 
                    ? 'table-row' 
                    : 'none';
            }
        });
    });
});

// Stackable Accordions


// const tl = gsap.timeline({
//   scrollTrigger: {
//       trigger: '.block-stackable-accordion-accordions',
//       pin: true,
//       start: 'top top',
//       end: 'bottom top',
//       scrub: 1,
//       ease: 'linear',
//     }
// })

// tl.to('.block-stackable-accordion-accordions-accordion-wysiwyg', {
//   height: 0,
//   paddingBottom: 0,
//   opacity: 0,
//   stagger: .5,
// })
// tl.to('block-stackable-accordion-accordions-accordion', {
//   marginBottom: -15,
//   stagger: .5,
// }, '<')

